import httpClient from './httpClient';

class RolesService {
  // Get all roles and permissions
  async getRoles() {
    try {
      console.log('RolesService: Fetching roles and permissions');
      const response = await httpClient.get('/api/admin/roles-permissions?permissions');
      console.log('RolesService: Raw response from httpClient:', response);
      
      return response;
    } catch (error) {
      console.error('RolesService: Error in getRoles:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء جلب الأدوار والصلاحيات'
      };
    }
  }
}

export default new RolesService();
